// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"3f22d97c","513":"858b3801","787":"d494d409"}[chunkId] + ".chunk.js";
};